// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__3yIt-","active":"downloadDropdown_active__1PIhY"};